import React from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import { goBack, push } from "connected-react-router";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import { ResponsiveHeader } from "pages/_components/header";

const StepVerifyUserCredentialsSuccess = ({ isMobile }) => {
    const dispatch = useDispatch();

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const onContinue = () => {
        dispatch(push("/onboarding/stepSelectEnrolledUserRole"));
    };

    return (
        <>
            {isMobile && <ResponsiveHeader ticket id="onboarding.enrolled.user" onClickBack={onHeaderBack} />}
            <MainContainer>
                {!isMobile && <Head title="onboarding.enrolled.user" onBack={isMobile && onHeaderBack} />}
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText
                            text={i18nUtils.get(
                                "onboarding.stepVerifyCredentials.success.1",
                                "¡Ya validamos tus credenciales!",
                            )}
                        />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image src="figma/illustrations/onboarding3.svg" className="svg-image logo" />
                </div>
                <div className="box box-border-soft">
                    {" "}
                    <CustomText
                        text={i18nUtils.get(
                            "onboarding.stepVerifyCredentials.success.2",
                            "Ahora te pediremos seleccionar tu rol en la empresa.",
                        )}
                    />
                </div>
                <div className="form-actions">
                    <Button bsStyle="primary" label="global.continue" loading={false} onClick={onContinue} />
                </div>
            </MainContainer>
        </>
    );
};

StepVerifyUserCredentialsSuccess.propTypes = {
    isMobile: bool.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(StepVerifyUserCredentialsSuccess);
